import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { App } from '@capacitor/app';
import { EventEmitter } from './event-emitter';

const deviceEvents = new EventEmitter();

//https://capacitorjs.com/docs/apis/haptics
const hapticsImpactMedium = async () => {
    await Haptics.impact({ style: ImpactStyle.Medium });
};

const hapticsImpactLight = async () => {
    await Haptics.impact({ style: ImpactStyle.Light });
};

const hapticsImpactHeavy = async () => {
    await Haptics.impact({ style: ImpactStyle.Heavy });
};

const hapticsVibrate = async () => {
    await Haptics.vibrate();
};

const hapticsSelectionStart = async () => {
    await Haptics.selectionStart();
};

const hapticsSelectionChanged = async () => {
    await Haptics.selectionChanged();
};

const hapticsSelectionEnd = async () => {
    await Haptics.selectionEnd();
};

App.addListener('backButton', () => deviceEvents.emit('backButton'));
App.addListener('appStateChange', (params) => deviceEvents.emit('appStateChange', params));

export {
    hapticsImpactMedium,
    hapticsImpactLight,
    hapticsImpactHeavy,
    hapticsVibrate,
    hapticsSelectionStart,
    hapticsSelectionChanged,
    hapticsSelectionEnd,
    deviceEvents
}